	<template>
	<div class="container">
	<b-row v-if="!isLoading">
	<b-container>
		<h4>
		<label>País</label>
		<select v-model="pais" @click="f_seleccione_facturas()">
			<option
				v-for="(item, idx) in listPaises"
				:key="idx"
				:value="item.pais">
				{{item.pais}}
			</option>
		</select>
		</h4>
		<md-table v-model="listFacturas" md-card md-fixed-header @md-selected="f_muestra">
		<md-table-toolbar>
			<h1 class="md-title"><b><i>{{f_titulo()}}</i></b></h1>
		</md-table-toolbar>
		<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
			<md-table-cell :md-label="labels.fecha" class="text-left border">{{item.fecha_factura}}</md-table-cell>
			<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
			<md-table-cell :md-label="labels.proveedor" class="text-left border">{{item.nombre}}</md-table-cell>
			<md-table-cell :md-label="labels.cantidad" class="text-left border">{{item.cantidad}}</md-table-cell>
			<md-table-cell :md-label="labels.items" class="text-left border">{{item.items}}</md-table-cell>
		</md-table-row>
		</md-table>
	</b-container>
	<md-dialog :md-active.sync="muestreFacturas">
		<md-dialog-title class="text-center"><h3><b><i>{{f_titulo()}}</i></b>
		</h3></md-dialog-title>
		<md-dialog-content>
			<md-table v-model="listFacturasCliente" md-card md-fixed-header @md-selected="f_muestra_detalle">
				<md-table-row slot="md-table-row" slot-scope="{ item }" md-selectable="single">
					<md-table-cell :md-label="labels.fecha" class="text-left border">{{item.fecha_factura}}</md-table-cell>
					<md-table-cell :md-label="labels.factura" class="text-left border">{{item.factura}}</md-table-cell>
					<md-table-cell :md-label="labels.identificacion" class="text-left border">{{item.identificacion}}</md-table-cell>
					<md-table-cell :md-label="labels.proveedor" class="text-left border">{{item.nombre}}</md-table-cell>
					<md-table-cell :md-label="labels.impuesto" class="text-right border">{{item.impuesto_total}}</md-table-cell>
					<md-table-cell :md-label="labels.valor_total" class="text-right border">{{item.valor_total}}</md-table-cell>
					<md-table-cell :md-label="labels.documento_contable" class="text-left border">{{item.documento_contable}}</md-table-cell>
				</md-table-row>
			</md-table>
			<md-dialog-actions>
				<md-button class="md-accent" @click="muestreFacturas = false">Cerrar</md-button>
			</md-dialog-actions>
		</md-dialog-content>
	</md-dialog>
	<md-dialog :md-active.sync="muestreDetalleFacturas">
		<md-dialog-content>
			<md-table >
				<md-table-row >
					<md-table-cell class="text-right border">Factura</md-table-cell>
					<md-table-cell class="text-left border">{{factura.fecha_factura}}</md-table-cell>
					<md-table-cell class="text-left border">{{factura.factura}}</md-table-cell>
				</md-table-row>
				<md-table-row >
					<md-table-cell class="text-right border">Identificación</md-table-cell>
					<md-table-cell class="text-left border">{{factura.identificacion}}</md-table-cell>
					<md-table-cell class="text-left border">{{factura.nombre}}</md-table-cell>
				</md-table-row>
				<md-table-row >
					<md-table-cell class="text-right border">Pedido/Remision</md-table-cell>
					<md-table-cell class="text-left border">{{factura.pedido}}</md-table-cell>
					<md-table-cell v-if="factura.remision != 'NULL'" class="text-left border">{{factura.remision}}</md-table-cell>
				</md-table-row>
				<md-table-row v-if="factura.categoria0 != 'NULL'">
					<md-table-cell class="text-right border">Impuesto(s)</md-table-cell>
					<md-table-cell class="text-right border">{{factura.categoria0}}</md-table-cell>
					<md-table-cell class="text-right border">{{factura.impuesto0}}</md-table-cell>
				</md-table-row>
				<md-table-row v-if="factura.categoria1 != null">
					<md-table-cell class="text-right border"></md-table-cell>
					<md-table-cell class="text-right border">{{factura.categoria1}}</md-table-cell>
					<md-table-cell class="text-right border">{{factura.impuesto1}}</md-table-cell>
				</md-table-row>
				<md-table-row v-if="factura.categoria2 != null">
					<md-table-cell class="text-right border"></md-table-cell>
					<md-table-cell class="text-right border">{{factura.categoria2}}</md-table-cell>
					<md-table-cell class="text-right border">{{factura.impuesto2}}</md-table-cell>
				</md-table-row>
				<md-table-row >
					<md-table-cell class="text-right border">Valor/Impuestos</md-table-cell>
					<md-table-cell class="text-right border">{{factura.impuesto_total}}</md-table-cell>
					<md-table-cell class="text-right border">{{factura.valor}}</md-table-cell>
				</md-table-row>
				<md-table-row >
					<md-table-cell class="text-right border">Total</md-table-cell>
					<md-table-cell class="text-right border">{{f_estado(factura.estado)}}</md-table-cell>
					<md-table-cell class="text-right border">{{factura.valor_total}}</md-table-cell>
				</md-table-row>
				<md-table-row v-if="factura.id_lider >0">
					<md-table-cell class="text-right border">Lider/Analista</md-table-cell>
					<md-table-cell class="text-left border">{{f_usuario_nombre(factura.id_lider)}}</md-table-cell>
					<md-table-cell v-if="factura.id_usuario>0" class="text-left border">{{f_usuario_nombre(factura.id_usuario)}}</md-table-cell>
					<md-table-cell v-else class="text-left border"></md-table-cell>
				</md-table-row>
				<md-table-row v-if="factura.documento_contable">
					<md-table-cell class="text-right border">Comprobante Contable</md-table-cell>
					<md-table-cell class="text-right border"></md-table-cell>
					<md-table-cell class="text-left border">{{factura.documento_contable}}</md-table-cell>
				</md-table-row>
			</md-table>
			<md-dialog-actions>
				<md-button class="md-accent" @click="muestreDetalleFacturas = false">Cerrar</md-button>
			</md-dialog-actions>
		</md-dialog-content>
	</md-dialog>
	</b-row>
	</div>
	</template>
	<script>
import Factura from "@/services/Facturas"
import User from "@/services/User"
import Estado from "@/services/Estados"

export default {
name:'Facturas',
data: () => ({
	isLoading: false,
	selecciona: false,
	opcion: 0,
	factura: '',
	pais: '',
	titulo_factura: "",
	users : [],
	listEstados : [],
	listFacturas : [],
	listFacturasG : [],
	listPaises : [],
	listFacturasCliente : [],
	muestreFacturas: false,
	muestreDetalleFacturas: false,
	recarga: '',
}),
computed:{
labels(){
	if (this.$store.state._language == "es-ES") {
		return {
			title : "FACTURAS",
			factura : "Número Factura",
			fecha : "Fecha Factura",
			identificacion : "Número Identificación",
			proveedor : "Nombre del Proveedor",
			cantidad : "Facturas",
			pedido : "Número Pedido",
			valor : "Valor Bruto",
			impuesto0 : "Impuesto0",
			categoria0 : "Categoria0",
			impuesto1 : "Impuesto1",
			categoria1 : "Categoria1",
			impuesto2 : "Impuesto2",
			categoria2 : "Categoria2",
			impuesto : "Total Impuesto",
			valor_total : "Total Factura",
			items : "Items",
			documento_contable : "Doc Contable",
		}
	}else{
		return {
			title : "INVOICES",
			factura : "Invoice",
			fecha : "Date",
			identificacion : "Identification",
			proveedor : "Name",
			cantidad : "Invoices",
			pedido : "Order",
			valor : "Amount",
			impuesto0 : "Tax0",
			categoria0 : "Category0",
			impuesto1 : "Tax1",
			categoria1 : "Category1",
			impuesto2 : "Tax2",
			categoria2 : "Category2",
			impuesto : "Taxes",
			valor_total : "Total Amount",
			items : "Items",
		}
	}
}
},
mounted(){
	let fgl_lider =this.$store.state.userId 
	let fgl_usuario =this.$store.state.userId
	if	(this.$route.name == "porasignar") {
		this.opcion=0
	}
	if	(this.$route.name == "porcontabilizar") {
		this.opcion=1
	}
	if	(this.$route.name == "contabilizadas") {
		this.opcion=2
	}
	Factura.leaFacturas("consultar",this.opcion,fgl_lider,fgl_usuario)
	.then((res) => {
		this.listFacturasG = res.data.listFacturas
		this.listPaises = res.data.listPaises
	})
	.catch((err) => {
		console.log(err)
	})
	User.getAllUsers(this.$store.state.userName)
	.then((result) => {
		this.users = result.data.users;
	})
	.catch((err) => {
		console.log(err)
	})

	Estado.leaEstados(false)
	.then((result) => {
		this.listEstados = result.data.listEstados;
	})
	.catch((err) => {
		console.log(err)
	})
},
methods:{
	f_titulo() {
		if	(this.$route.name == "porasignar") {
			return "FACTURAS POR ASIGNAR"
		}
		if	(this.$route.name == "porcontabilizar") {
			return "FACTURAS POR CONTABILIZAR"
		}
		if	(this.$route.name == "contabilizadas") {
			return "FACTURAS CONTABILIZADAS"
		}
		return "SIN INFORMACION "+this.$route.name
	},
	f_muestra(r_proveedor) {
		let fgl_lider =this.$store.state.userId 
		let fgl_usuario =this.$store.state.userId
		this.muestreFacturas=true
		Factura.leaFacturasCliente("consultar",r_proveedor.fecha_factura,r_proveedor.identificacion,this.opcion,fgl_lider,fgl_usuario)
		.then((res) => {
			this.listFacturasCliente = res.data.listFacturasCliente
		})
		.catch((err) => {
			console.log(err)
		})
		
	},
	f_muestra_detalle(r_factura) {
		this.factura=r_factura
		this.muestreDetalleFacturas=true
	},
	f_usuario_nombre(id) {
		if	(id === undefined) {
			return "Indefinida"
		}
		const usuario = this.users.find((usuario) => usuario.id == id)
		return usuario.name
	},
	f_seleccione_facturas() {
		this.listFacturas = this.listFacturasG.filter((factura) => factura.pais == this.pais)
	},
	f_estado(estado) {
		if	(estado == null || estado == undefined) {
			return ""
		}
		const v_estado = this.listEstados.find((r_estado) => r_estado.estado == estado)
		if	(v_estado == undefined) {
			return "Estado "+estado
		}
		return v_estado.descripcion
	}
}

}
</script>

<style>

</style>
